// Vendors
import { requestHasSuccessStatus } from '@openbank/cf-ui-framework';
// Services
import {
  completeOpenbankingService,
  invalidateOpenbankingService,
} from '../services/proof-income-method.service';
// Types
import { ProofIncomeApiBuilderType } from '../types/proof-income-method-api-response.type';

const completeOpenbankingResolver = async (
  props: ProofIncomeApiBuilderType
): Promise<[boolean, number]> => {
  const [, { status }] = await completeOpenbankingService(props);

  return [!requestHasSuccessStatus(status), status];
};

const invalidateOpenbankingResolver = async (
  identificationId: string
): Promise<[boolean, number]> => {
  const [, { status }] = await invalidateOpenbankingService(identificationId);

  return [requestHasSuccessStatus(status), status];
};

export { completeOpenbankingResolver, invalidateOpenbankingResolver };
